var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.condition)?[_vm._t("truthy")]:[_vm._t("falsy")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }